import KeepgoingRoute from "@/views/keepgoing/route.vue";
import KeepgoingIndex from "@/views/keepgoing/Index.vue";
import ProductList from "@/views/keepgoing/ProductList.vue";
import Present from "@/views/keepgoing/Present.vue";
import PresentComplete from "@/views/keepgoing/PresentComplete.vue";

export default {
  path: "/keepgoing",
  component: KeepgoingRoute,
  children: [
    {
      path: "",
      name: "KeepgoingIndex",
      component: KeepgoingIndex
    },
    {
      path: "productList",
      name: "KeepgoingProductList",
      component: ProductList
    },
    {
      path: "present",
      name: "KeepgoingPresent",
      component: Present
    },
    {
      path: "present/complete",
      name: "KeepgoingPresentComplete",
      component: PresentComplete
    },

  ]
};



// WEBPACK FOOTER //
// ./src/router/keepgoing/index.js